import BasePage from './base-page';

export default BasePage;
